import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import NavLangStackEditor from './NavLangStackEditor';
import NavLinksArea from './NavLinksArea';
import {
  columnTemplate, updateAt, removeAt, missingLangs,
} from './navEditorState';

// The city's link columns, side by side like the rendered dropdown. Columns
// drag horizontally (type COL); their links drag anywhere (type LINK).
const NavColumnsBoard = ({
  itemIndex, cityIndex, columns, onChange,
}) => {
  const [editingTitle, setEditingTitle] = useState(null);

  return (
    <Droppable droppableId={`cols-${itemIndex}-${cityIndex}`} direction="horizontal" type="COL">
      {provided => (
        <div ref={provided.innerRef} {...provided.droppableProps} className="mnv-cols">
          {columns.map((column, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Draggable key={index} draggableId={`col-${itemIndex}-${cityIndex}-${index}`} index={index}>
              {p => (
                <div
                  ref={p.innerRef}
                  {...p.draggableProps}
                  className={`mnv-col${column.visible === false ? ' mnv-dim' : ''}`}
                >
                  <div className="mnv-colhead">
                    <span className="mnv-grip" {...p.dragHandleProps}>⋮⋮</span>
                    <button
                      type="button"
                      className="mnv-coltitle"
                      title="Edit column title (all languages)"
                      onClick={() => setEditingTitle(editingTitle === index ? null : index)}
                    >
                      {(column.title && column.title.en) || '(untitled)'}
                      {missingLangs(column.title).length > 0 && <i className="mnv-dot" title="missing translations" />}
                    </button>
                  </div>
                  {editingTitle === index && (
                    <NavLangStackEditor
                      label="Column title"
                      text={column.title}
                      onChangeText={title => onChange(updateAt(columns, index, { ...column, title }))}
                      visible={column.visible}
                      onToggleVisible={() => onChange(updateAt(columns, index, { ...column, visible: column.visible === false }))}
                      onDelete={() => { setEditingTitle(null); onChange(removeAt(columns, index)); }}
                      onDone={() => setEditingTitle(null)}
                    />
                  )}
                  <NavLinksArea
                    droppableId={`links-${itemIndex}-${cityIndex}-${index}`}
                    links={column.links || []}
                    addLabel="link"
                    onChange={links => onChange(updateAt(columns, index, { ...column, links }))}
                  />
                </div>
              )}
            </Draggable>
          ))}
          {provided.placeholder}
          <button type="button" className="mnv-ghostcol" onClick={() => onChange([...columns, columnTemplate()])}>
            + add column
          </button>
        </div>
      )}
    </Droppable>
  );
};

NavColumnsBoard.propTypes = {
  itemIndex: PropTypes.number.isRequired,
  cityIndex: PropTypes.number.isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default NavColumnsBoard;
